import { render, staticRenderFns } from "./RsaPazientePrescrizioneFarmaciEditModalComponent.vue?vue&type=template&id=2def280a&scoped=true"
import script from "./RsaPazientePrescrizioneFarmaciEditModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneFarmaciEditModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioneFarmaciEditModalComponent.vue?vue&type=style&index=0&id=2def280a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def280a",
  null
  
)

export default component.exports